// API for Agency Applications
// Saves to agency_applications table

import { supabaseAnon } from '../lib/supabase';

async function notifyAdmins(applicationId: string, data: AgencyApplicationData) {
  try {
    await supabaseAnon.functions.invoke('notify-new-application', {
      body: { type: 'agency', applicationId, ...data },
    });
  } catch (e) {
    console.error('Admin notification failed (non-critical):', e);
  }
}

export interface AgencyApplicationData {
  fullName: string;
  email: string;
  phone: string;
  instagram?: string;
  agencyName: string;
  agencySize: string;
  yearsInBusiness: string;
  currentCarriers?: string;
  websiteUrl?: string;
  state?: string;
  licenseStatus?: string;
  interviewDate: string;
  interviewTime: string;
  source: string;
}

export async function submitAgencyApplication(data: AgencyApplicationData): Promise<{ success: boolean; id?: string; error?: string }> {
  try {
    // Validation
    if (!data.fullName || !data.email || !data.phone || !data.agencyName || !data.agencySize || !data.yearsInBusiness || !data.interviewDate || !data.interviewTime) {
      return { success: false, error: 'Required fields are missing' };
    }

    // Email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(data.email)) {
      return { success: false, error: 'Invalid email format' };
    }

    // Insert into agency_applications table
    const { data: application, error } = await supabaseAnon
      .from('agency_applications')
      .insert({
        full_name: data.fullName,
        email: data.email,
        phone: data.phone,
        instagram: data.instagram || '',
        agency_name: data.agencyName,
        agency_size: data.agencySize,
        current_carriers: data.currentCarriers || '',
        website_url: data.websiteUrl || '',
        state: data.state || '',
        license_status: data.licenseStatus || '',
        experience: data.yearsInBusiness, // Map years in business to experience field
        interview_date: data.interviewDate,
        interview_time: data.interviewTime,
        source: data.source,
        status: 'pending',
      })
      .select('id')
      .single();

    if (error) {
      console.error('Supabase error:', error);
      
      if (error.code === '23505') {
        return { success: false, error: 'An application with this email already exists.' };
      }
      
      return { 
        success: false, 
        error: 'Failed to submit application. Please try again.' 
      };
    }

    console.log('Agency application submitted successfully:', application.id);

    notifyAdmins(application.id, data);

    return { 
      success: true, 
      id: application.id 
    };
    
  } catch (error) {
    console.error('Agency application submission error:', error);
    return { 
      success: false, 
      error: 'Internal server error. Please try again.' 
    };
  }
}
